var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 7.5H21C21.828 7.5 22.5 6.828 22.5 6C22.5 5.172 21.828 4.5 21 4.5H3C2.172 4.5 1.5 5.172 1.5 6C1.5 6.828 2.172 7.5 3 7.5ZM21 10.5H3C2.172 10.5 1.5 11.172 1.5 12C1.5 12.828 2.172 13.5 3 13.5H21C21.828 13.5 22.5 12.828 22.5 12C22.5 11.172 21.828 10.5 21 10.5ZM21 16.5H3C2.172 16.5 1.5 17.172 1.5 18C1.5 18.828 2.172 19.5 3 19.5H21C21.828 19.5 22.5 18.828 22.5 18C22.5 17.172 21.828 16.5 21 16.5Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.9181afade23010c545f46f7e5db35a59.svg";
export { ForwardRef as ReactComponent };